import classNames from 'classnames';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { getHTMLWarningIconsPartial } from 'components/map/marker-view/shared/html/html-marker-icons.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import * as pillStyle from 'styles/components/snippets/pill.module.scss';
import { SecondaryMarkerV2Data } from 'types/markerTypesV2/m-v2-core-shared.js';
import { IMarkerV2Warnings } from 'types/markerTypesV2/m-v2-warnings.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';
import { FlexDivCenteredIcon } from 'utilities/svg-display/svg-layout.js';
import { findHighestRankedHighSeasIcon } from 'utilities/weather-warnings/highestRankedHighSeasIcon.js';

const getWarningIconArr = ({
  mergeWarnings,
  warningsList,
}: {
  mergeWarnings?: boolean;
  warningsList?: IWarning[];
}): IconNameV1[] => {
  if (warningsList?.length) {
    if (mergeWarnings) {
      const highestRankedWarningIcon = findHighestRankedHighSeasIcon(warningsList);
      if (highestRankedWarningIcon) {
        return [highestRankedWarningIcon];
      }
    }
    return Array.from(getHTMLWarningIconsPartial<IconNameV1>({ warnings: warningsList }));
  }

  return [];
};

export const MarkerV2SecondaryData = ({
  secondaryData = [],
  warnings,
  warningsList,
}: {
  secondaryData?: SecondaryMarkerV2Data[];
  warnings?: IMarkerV2Warnings;
  warningsList?: IWarning[];
}) => {
  if (warningsList?.length || secondaryData.length) {
    const warningIconArr = getWarningIconArr({ mergeWarnings: warnings?.mergeWarnings, warningsList });
    const paddingLabelH = Number(pillStyle.paddingLabelH); // see .pill--label-padding

    return (
      <div
        data-comp="marker-v2-secondary-data"
        className="u-bL-1 u-flex u-flexAlignItemsCenter"
        style={{ paddingLeft: `${paddingLabelH}px`, marginLeft: `${paddingLabelH}px` }}
      >
        {Array.from(warningIconArr).map((icon, index) => (
          <div
            key={index}
            className={classNames('u-flex-1 u-text-sm u-textBold')}
            style={index > 0 ? { marginLeft: `${paddingLabelH}px` } : {}}
          >
            <div data-comp="sec-data-item" className="u-flex u-flexAlignItemsCenter">
              {isNotNullOrUndefined(icon) && <FlexDivCenteredIcon icon={icon} />}
            </div>
          </div>
        ))}
        {secondaryData.map((data, index) => (
          <div
            key={index}
            className={classNames('u-flex-1 u-text-sm u-textBold')}
            style={index > 0 ? { marginLeft: `${paddingLabelH}px` } : {}}
          >
            <MarkerV2SecondaryDataItem secondaryDataItem={data} />
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export const MarkerV2SecondaryDataItem = ({ secondaryDataItem }: { secondaryDataItem: SecondaryMarkerV2Data }) => {
  const { icon, text } = secondaryDataItem;
  return (
    <div data-comp="sec-data-item" className="u-flex u-flexAlignItemsCenter">
      {isNotNullOrUndefined(icon) && <FlexDivCenteredIcon v={2} icon={icon} />}
      {isNotNullOrUndefined(text) && <div className="u-flex-1 u-textNoWrap">{text}</div>}
    </div>
  );
};
